import { useContext, useMemo } from "react";
import { FormContext } from "../../context/FormContext";

// If you already export proper types for clientSettings/features, use them instead:
type Features = Record<string, boolean>;

export function useFeatureFlag<K extends keyof Features>(flag: K, defaultValue = false) {
  const { formState } = useContext(FormContext);
  const enabled = formState?.clientSettings?.features?.[flag];

  // Coerce undefined → defaultValue (usually false)
  return useMemo(
    () => (typeof enabled === "boolean" ? enabled : defaultValue),
    [enabled, defaultValue],
  );
}
